'use strict';

/**
 *
 * @name: followUs
 *
 */

import DirectiveTemplate from './nn-social-extended.directive.html';
import './nn-social-extended.directive.scss';

function NnSocialExtended() {

  'ngInject';

  return {
    replace: true,
    restrict: 'A',
    scope: {
      content: '&',
      loaded: '='
    },
    template: DirectiveTemplate,
    transclude: true,
    link: function(scope, element) {

      scope.item = scope.content();
      scope.loaded = true;
      scope.socials = _getSocials(scope.item.jsonData.sources);

      function _terminate() {

        scope.$destroy();
        element.find('*').remove();
        element.remove();
      }

      function _getSocials(data){
        var _data = (data || []).filter(function(item){ return item.url && item.imageUrl; });

        if(!data.length){
          _terminate();
          return;
        }

        return _data;
      }
    }
  };
}

export default NnSocialExtended;



// WEBPACK FOOTER //
// ./app/components/nn-modules/nn-social-extended/nn-social-extended.directive.js